<template>
  <div class="qaqc-dl-test-view">
    <DataQualityScorecardTable
      :rows="scorecardRows"
      :summary="scorecardSummary"
      dataset-label="DL Dataset"
    />
    <ValidationPassRateMatrixTable
      :rows="validationMatrixRows"
      :title="validationMatrixTitle"
      :description="validationMatrixDescription"
      matrix-test-context="dl"
    />
    <div class="qaqc-overview-distribution-section">
      <DistributionPlotsSection
        :plot-options="distributionPlotOptions"
        :selected-plot-id="selectedPlotId"
        :distribution-data="distributionData"
        @update:selected-plot-id="$emit('update:selectedPlotId', $event)"
      />
    </div>
    <ConsistencyCheckSection
      :cross-test-rows="consistencyCrossTestRows"
      :ordering-rows="consistencyOrderingRows"
    />
    <div class="qaqc-overview-distribution-section">
      <DlAuxDistributionSection
        section-title="Total Material Balance Error Distribution"
        :plot-options="dlMaterialBalancePlotOptions"
        :selected-plot-id="selectedMaterialBalancePlotId"
        :distribution-data="dlMaterialBalanceDistributionData"
        csv-file-name="dl_material_balance_distribution.csv"
        @update:selected-plot-id="$emit('update:selectedMaterialBalancePlotId', $event)"
      />
    </div>
    <EquilibriumPlotLinearitySection :rows="equilibriumPlotRows" />
    <div class="qaqc-overview-distribution-section">
      <DlAuxDistributionSection
        section-title="Overall Feed Deviation Distribution (mole%)"
        :plot-options="[]"
        :distribution-data="dlFeedDeviationData"
        csv-file-name="dl_overall_feed_deviation.csv"
      />
    </div>
  </div>
</template>

<script>
import DataQualityScorecardTable from "./DataQualityScorecardTable.vue";
import ValidationPassRateMatrixTable from "./ValidationPassRateMatrixTable.vue";
import ConsistencyCheckSection from "./ConsistencyCheckSection.vue";
import EquilibriumPlotLinearitySection from "./EquilibriumPlotLinearitySection.vue";
import DistributionPlotsSection from "./DistributionPlotsSection.vue";
import DlAuxDistributionSection from "./DlAuxDistributionSection.vue";

export default {
  name: "DLTestView",
  components: {
    DataQualityScorecardTable,
    ValidationPassRateMatrixTable,
    ConsistencyCheckSection,
    EquilibriumPlotLinearitySection,
    DistributionPlotsSection,
    DlAuxDistributionSection,
  },
  props: {
    scorecardRows: { type: Array, default: () => [] },
    scorecardSummary: {
      type: Object,
      default: () => ({
        overallPassRate: "0%",
        passedQc: 0,
        pendingQc: 0,
        failed: 0,
      }),
    },
    validationMatrixRows: { type: Array, default: () => [] },
    validationMatrixTitle: { type: String, default: "Validation Pass Rate Matrix" },
    validationMatrixDescription: { type: String, default: "Percentage of all DL samples passing each validation check" },
    consistencyCrossTestRows: { type: Array, default: () => [] },
    consistencyOrderingRows: { type: Array, default: () => [] },
    equilibriumPlotRows: { type: Array, default: () => [] },
    distributionPlotOptions: { type: Array, default: () => [] },
    selectedPlotId: { type: String, default: "" },
    distributionData: { type: Object, default: () => ({}) },
    dlMaterialBalancePlotOptions: { type: Array, default: () => [] },
    selectedMaterialBalancePlotId: { type: String, default: "" },
    dlMaterialBalanceDistributionData: { type: Object, default: () => ({}) },
    dlFeedDeviationData: { type: Object, default: () => ({}) },
  },
  emits: ["update:selectedPlotId", "update:selectedMaterialBalancePlotId"],
};
</script>
